import type {CredentialsUpdateResult} from 'src/openapi/admin/models/CredentialsUpdateResult';

export const getConnectionErrorMessage = (connectionStatus: CredentialsUpdateResult) => {
    if (connectionStatus.type?.code === 'dup') {
        return connectionStatus.type.description + '\nAccounts with identical Org ID: ' +
            connectionStatus.accountsWithIdenticalOrgId.join('\n');
    } else {
        return connectionStatus.type?.description || '';
    }
};
